// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

function aggregateTrophySources(rows) {
  return Belt_Array.reduce(rows, {
              status: "OK",
              numBronzeTrophies: 0,
              numSilverTrophies: 0,
              numGoldTrophies: 0
            }, (function (param) {
                var numBronzeTrophies = param.numBronzeTrophies;
                if (numBronzeTrophies !== undefined) {
                  var numSilverTrophies = param.numSilverTrophies;
                  if (numSilverTrophies !== undefined) {
                    var numGoldTrophies = param.numGoldTrophies;
                    if (numGoldTrophies !== undefined) {
                      return function (source) {
                        return {
                                status: "OK",
                                numBronzeTrophies: numBronzeTrophies + source.bronze | 0,
                                numSilverTrophies: numSilverTrophies + source.silver | 0,
                                numGoldTrophies: numGoldTrophies + source.gold | 0
                              };
                      };
                    }
                    
                  }
                  
                }
                throw {
                      RE_EXN_ID: "Match_failure",
                      _1: [
                        "ProfileTypesCobra.res",
                        95,
                        4
                      ],
                      Error: new Error()
                    };
              }));
}

function makeProps(state, hasFlag) {
  if (state.TAG === "LoadingInitialData") {
    return {
            areBadgesFeatureEnabled: Curry._1(hasFlag, "FeatBadges"),
            areHighFivesFeatureEnabled: Curry._1(hasFlag, "FeatSocial"),
            isProfileMine: state._0,
            playerData: {
              status: "LOADING"
            },
            trophyData: {
              status: "LOADING"
            },
            progressData: {
              status: "LOADING"
            },
            badgeData: {
              status: "LOADING"
            },
            mySocialData: {
              status: "LOADING",
              numHighFives: 0,
              numThumbsUp: 0
            },
            theirSocialData: {
              status: "LOADING",
              costPerHighFive: 0,
              costPerThumbsUp: 0,
              myGemCount: 0
            }
          };
  }
  var profile = state._1;
  var trophies = profile.trophies;
  var tmp;
  tmp = typeof trophies !== "object" ? (
      trophies === "TrophiesNotBuilt" ? ({
            status: "LOADING"
          }) : ({
            status: "DISABLED"
          })
    ) : aggregateTrophySources(trophies._0);
  return {
          areBadgesFeatureEnabled: Curry._1(hasFlag, "FeatBadges"),
          areHighFivesFeatureEnabled: Curry._1(hasFlag, "FeatSocial"),
          avatar: profile.avatar,
          isProfileMine: state._0,
          playerData: {
            status: "OK",
            shortName: profile.user.shortName,
            numGems: profile.user.gems,
            country: profile.user.country
          },
          trophyData: tmp,
          progressData: {
            status: "OK",
            startLevelNum: profile.spBar.fromLevel,
            nextLevelNum: profile.spBar.toLevel,
            currentXP: profile.spBar.currentValue,
            minXP: profile.spBar.fromValue,
            maxXP: profile.spBar.toValue,
            hasReachedMaxLevel: profile.spBar.hasReachedMaxLevel
          },
          badgeData: {
            status: "OK",
            badges: Curry._1(hasFlag, {
                  NAME: "Unleash",
                  VAL: "release_sxHasSocialBadges"
                }) ? profile.badges : profile.badges.filter(function (b) {
                    var match = b.rule;
                    if (typeof match !== "object") {
                      return true;
                    }
                    switch (match.TAG) {
                      case "BadgeHighFives" :
                      case "BadgeThumbsUp" :
                          return false;
                      default:
                        return true;
                    }
                  })
          },
          mySocialData: {
            status: "OK",
            numHighFives: profile.myUser.highFives.received,
            numThumbsUp: profile.myUser.thumbsUp.received
          },
          theirSocialData: {
            status: "OK",
            costPerHighFive: 5,
            costPerThumbsUp: 5,
            myGemCount: profile.myUser.gems
          }
        };
}

var PlayerEquippedFragment;

export {
  PlayerEquippedFragment ,
  aggregateTrophySources ,
  makeProps ,
}
/* No side effect */
